let routes = [
  {
    path: "/tax_infos",
    name: "TaxInformations",
    meta: {
      requireAuthorize: true,
      anchor: "#jumpBreadcrumb"
    },
    component: () =>
      import("@/components/admin/TaxInformations/TaxInformations.vue")
  },

  {
    path: "/person_duplicate_management",
    name: "PersonDuplicate",
    meta: {
      requireAuthorize: true,
      anchor: "#jumpBreadcrumb"
    },
    component: () =>
      import("@/components/admin/duplicates/PersonDuplicatesManagement.vue")
  },

  {
    path: "/invoices",
    meta: {
      requireAuthorize: true,
      breadcrumbI18n: "navigation:breadcrumbs.invoices.title",
      anchor: "#jumpBreadcrumb"
    },

    component: {
      render(h) {
        return h("router-view");
      }
    },
    children: [
      {
        path: "",
        name: "InvoicesManagement",
        props: route => ({ foreignFilter: route.query.foreignFilter }),
        meta: {
          requireAuthorize: true,
          anchor: "#jumpBreadcrumb"
        },
        component: () =>
          import("@/components/admin/invoices/InvoicesManagement.vue")
      },
      {
        path: "/invoices/new",
        name: "InvoiceForm",
        meta: {
          requireAuthorize: true,
          anchor: "#jumpBreadcrumb",
          breadcrumbI18n: "navigation:breadcrumbs.newInvoice.title"
        },
        component: () => import("@/components/admin/invoices/InvoiceForm.vue")
      },
      {
        path: "/invoice/:invoiceId/edit",
        name: "InvoiceFormEdit",
        props: true,
        meta: {
          requireAuthorize: true,
          anchor: "#jumpBreadcrumb",
          breadcrumbI18n: "navigation:breadcrumbs.editInvoice.title"
        },
        component: () => import("@/components/admin/invoices/InvoiceForm.vue")
      }
    ]
  },

  {
    path: "/person_debt_balances",
    name: "PersonDebtBalances",
    meta: {
      requireAuthorize: true,
      anchor: "#jumpBreadcrumb"
    },
    component: () => import("@/components/admin/PersonDebtBalances.vue")
  },

  {
    path: "/person_certificates",
    name: "PersonCertificateManagement",
    meta: {
      requireAuthorize: true,
      anchor: "#jumpBreadcrumb"
    },
    component: () => import("@/components/admin/PersonCertificates.vue")
  },

  {
    path: "/official_exams",
    name: "PersonExamsManagement",
    meta: {
      requireAuthorize: true,
      anchor: "#jumpBreadcrumb"
    },
    component: () => import("@/components/admin/PersonExamsManagement.vue")
  },

  {
    path: "/sanctions_management",
    name: "SanctionsManagement",
    meta: {
      requireAuthorize: true,
      anchor: "#jumpBreadcrumb"
    },
    component: () => import("@/components/admin/SanctionsManagement.vue")
  },
  {
    path: "/reports_viewer",
    name: "ReportsViewer",
    meta: {
      breadcrumb: "Reports viewer",
      requireAuthorize: true,
      anchor: "#jumpMobile"
    },
    component: () => import("@/components/admin/ReportsViewer.vue")
  },
  {
    path: "/external_result/new",
    name: "NewExternalResultForm",
    meta: {
      breadcrumb: "Create new external result",
      requireAuthorize: true,
      anchor: "#jumpBreadcrumb"
    },
    component: () =>
      import("@/components/external_results/ExternalResultForm.vue")
  },
  {
    path: "/external_result/:applicationId",
    name: "ExternalResultForm",
    props: true,
    meta: {
      breadcrumb: "External result",
      requireAuthorize: true,
      anchor: "#jumpMobile"
    },
    component: () =>
      import("@/components/external_results/ExternalResultForm.vue")
  },
  {
    path: "/admin/external_result_reports",
    name: "ExternalResultReports",
    meta: {
      breadcrumb: "External result reports",
      requireAuthorize: true,
      anchor: "#jumpMobile"
    },
    component: () =>
      import("@/components/admin/external_results/ExternalResultReports.vue")
  },
  {
    path: "/admin/audit",
    name: "AdminAuditLog",
    component: () => import("@/components/admin/AuditLog/AuditLog.vue"),
    props: route => ({ organisationId: route.query.organisationId }),
    meta: { requireAuthorize: true, anchor: "#jumpMobile" }
  },
  {
    path: "/admin/organisations",
    name: "AdminOrganisations",
    component: () => import("@/components/admin/AdminOrganisations.vue"),
    meta: { requireAuthorize: true, anchor: "#jumpMobile" }
  },
  {
    path: "/admin/person_applications",
    name: "PersonApplications",
    component: () => import("@/components/admin/PersonApplications.vue"),
    meta: { requireAuthorize: true, anchor: "#jumpMobile" }
  },
  {
    path: "/admin/horse_applications",
    name: "HorseApplications",
    component: () =>
      import("@/components/admin/HorseApplications/HorseApplications.vue"),
    meta: { requireAuthorize: true, anchor: "#jumpMobile" }
  },
  {
    path: "/admin/payouts",
    name: "AdminPayouts",
    component: () => import("@/components/admin/Payouts.vue"),
    meta: { requireAuthorize: true, anchor: "#jumpMobile" }
  },
  {
    path: "/admin/payments",
    name: "AdminPayments",
    props: route => {
      return { foreignFilter: route.query.foreignFilter };
    },
    component: () => import("@/components/admin/Payments.vue"),
    meta: { requireAuthorize: true, anchor: "#jumpMobile" }
  },
  {
    path: "/admin/taxoffice",
    name: "TaxOffice",
    forFederation: ["FI"],
    component: () => import("@/components/admin/TaxOffice.vue"),
    meta: { requireAuthorize: true, anchor: "#jumpMobile" }
  },
  {
    path: "/admin/tehnical",
    name: "Tehnical",
    component: () => import("@/components/admin/Tehnical.vue"),
    meta: { requireAuthorize: true, anchor: "#jumpMobile" }
  },
  {
    path: "/admin/officials",
    name: "OfficialDashboard",
    component: () =>
      import("@/components/admin/Officials/OfficialDashboard.vue"),
    meta: {
      requireAuthorize: true,
      anchor: "#jumpMobile",
      breadcrumbI18n: "navigation:menu.officials"
    }
  },
  {
    path: "/admin/sales",
    name: "SalesPage",
    component: () => import("@/components/admin/SalesPage.vue"),
    meta: {
      requireAuthorize: true,
      anchor: "#jumpMobile",
      breadcrumbI18n: "navigation:menu.sales"
    }
  }
];

export default routes;
